import styled from 'styled-components';

export const FormItem = styled.div`
  label {
    font-size: ${(props) => props.theme.labelSize};
  }

  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  width: 100%;
`;

export const Input = styled.input`
  &:focus {
    box-shadow:
      0 0 0 0 #fff,
      0 0 0 2px rgba(99, 102, 241, 0.2),
      0 0 #0000,
      0 0 #0000;
  }
`;

export const MultiColumnContainer = styled.div`
  margin-top: 1rem;
`;

export const MultiColumnWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-block: 0.25rem;
  align-items: flex-end;
  gap: 1rem;
`;

export const Container = styled.div`
  max-width: 500px;
  margin-inline: auto;
  margin-bottom: 1rem;
  border-radius: 0.75rem;
  background: navajowhite;
  border: 1px solid #b88925;
  box-shadow: inset 0 0 0 1px #b88925;
  overflow: hidden;

  h3 {
    margin: 0.5rem 1rem;
    font-size: 1.125em;
    font-weight: 600;
  }
`;

export const PointsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  & > div:first-child {
    flex-basis: 100%;
  }

  & > div:last-child {
    flex-basis: 50%;
  }
`;

export const ErrorMessage = styled.div`
  color: red;
  font-size: 0.875rem;
  margin-top: 0.25rem;
`;

export const PointItem = styled.div<{ isHalf: boolean }>`
  flex-basis: ${(props) => (props.isHalf ? '50%' : '33.33%')};
  box-sizing: border-box;
`;

export const RadioWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  margin-bottom: 1rem;

  label {
    flex-basis: 50%;
  }
`;

export const CustomRadio = styled.label`
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
`;

export const HiddenRadio = styled.input`
  display: none;

  &:checked + div {
    border: 2px solid #a35110;

    > i {
      opacity: 1;
      transform: translateX(-50%) scale(1);
    }
  }
`;

export const Checkmark = styled.i`
  color: white;
  background-color: #a35110;
  font-size: 1rem;
  position: absolute;
  top: 3px;
  right: -10px;
  transform: translateX(-50%) scale(1.4);
  border-radius: 50%;
  width: 1.125rem;
  height: 1.125rem;
  padding: 5px;
  transition: 0.3s;
  pointer-events: none;
  opacity: 0;
`;

export const RadioContent = styled.div<{ isActive?: boolean }>`
  border-radius: 10px;
  height: 100%;
  position: relative;
  background-color: white;
  border: 2px solid ${({ isActive }) => (isActive ? '#FFDAE9' : 'transparent')};
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;

  ${Checkmark} {
    opacity: ${({ isActive }) => (isActive ? 1 : 0)};
    transform: ${({ isActive }) =>
      isActive ? 'translateX(-50%) scale(1)' : 'translateX(-50%) scale(1.4)'};
    transition:
      opacity 0.3s ease,
      transform 0.3s ease;
  }
`;

export const RadioTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 700;
  text-transform: uppercase;
`;
